



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DEFAULT_SEVERITIES } from './SeverityIcon/SeverityModel';
import SeverityInterface from './SeverityIcon/SeverityInterface';

@Component
export default class BadgeMenuNotification extends Vue {
    @Prop({ required: true, type: Object })
    public notification!: any;
    @Prop({ required: true, type: Boolean })
    public showToolTips!: boolean;
    @Prop({ required: false, type: Boolean, default: false })
    public right!: boolean;
    @Prop({ required: false, type: Boolean, default: false })
    public left!: boolean;
    @Prop({ required: false, type: Boolean, default: false })
    public top!: boolean;
    @Prop({ required: false, type: Boolean, default: false })
    public bottom!: boolean;
    @Prop({ required: false, type: String, default: '' })
    public offsetX!: string;
    @Prop({ required: false, type: String, default: '' })
    public offsetY!: string;
    public severities: SeverityInterface = DEFAULT_SEVERITIES;

    public getColor(): string {
        if (this.notification.color) {
            return this.notification.color;
        }

        if (this.notification.severity) {
            return this.severities[this.notification.severity].color;
        }

        return '';
    }
}
